var _defs, _circle, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#f38526",
    className: "color88c5cc svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040404",
    d: "M448.584,424.556L419.908,384L303.82,356h-48h-48L91.908,384l-28.54,40.508 C110.292,478.1,179.168,512,256,512C332.808,512,401.668,478.124,448.584,424.556z",
    className: "color263740 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M255.812,356h-48L176,364.384l59.876,146.756C242.524,511.656,249.22,512,256,512 c6.684,0,13.28-0.336,19.84-0.84L336,364.46L303.812,356H255.812z",
    className: "colorccc svgShape"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.812,
    cy: 362,
    fill: "#f5f5f5",
    rx: 56,
    ry: 22,
    className: "colorf5f5f5 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6cbc3",
    d: "M305.484,350.252h0.02l-13.692-42.584l-36-2.664l-36,2.664l-13.696,42.584h0.024 c-0.204,0.584-0.328,1.18-0.328,1.772c0,8.824,22.388,15.972,50,15.972c27.608,0,50-7.148,50-15.972 C305.812,351.428,305.688,350.836,305.484,350.252z",
    className: "colore6cbc3 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9bfb8",
    d: "M305.484,350.252h0.02l-13.692-42.584l-36-2.664l-7,0.516l29,2.148l13.692,42.584h-0.02 c0.204,0.584,0.328,1.18,0.328,1.772c0,8.064-18.712,14.712-43,15.8c2.288,0.096,4.616,0.172,7,0.172c27.608,0,50-7.148,50-15.972 C305.812,351.428,305.688,350.836,305.484,350.252z",
    className: "colord9bfb8 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe1d9",
    d: "M359.812,136V94.388c0-32.452-23.084-58.388-104-58.388s-104,25.936-104,58.388V136 c0,0-16,1.18-16,12v44.276c0,10.816,4,19.724,16,19.724c0,54.084,48.092,116,104,116s104-61.916,104-116c12,0,16-8.908,16-19.724 V148C375.812,137.18,359.812,136,359.812,136z",
    className: "colorffe1d9 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2d6ce",
    d: "M255.812,36c-2.048,0-4.032,0.028-6,0.06c76.048,1.264,98,26.696,98,58.328V136v76 c0,52.14-44.704,111.532-98,115.744c1.992,0.156,3.988,0.256,6,0.256c55.908,0,104-61.916,104-116v-76V94.388 C359.812,61.936,336.736,36,255.812,36z",
    className: "colorf2d6ce svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M255.812,36c-80.916,0-104,25.936-104,58.388V136v44c3.704-18.52,14.28-71.324,38.064-88.56 c18.92,5.408,41.576,8.56,65.936,8.56c24.356,0,47.016-3.156,65.936-8.56c23.776,17.24,34.36,70.04,38.064,88.56v-44V94.388 C359.812,61.936,336.736,36,255.812,36z",
    className: "color242424 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M255.812,36c-2.04,0-4.02,0.028-5.988,0.06c76.036,1.268,97.988,26.696,97.988,58.328v39.48 c6.372,18.112,10.1,36.632,12,46.132v-44V94.388C359.812,61.936,336.736,36,255.812,36z",
    className: "color1a1a1a svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6b217",
    d: "M268,380h-24l-8,24l8,8l-10.6,98.944C240.852,511.6,248.384,512,256,512s15.148-0.4,22.6-1.056 L268,412l8-8L268,380z",
    className: "colorcc584c svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5f5f5",
    points: "306 352.028 255.812 368 275.812 412 319.812 360",
    className: "colorf5f5f5 svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5f5f5",
    points: "205.624 352.028 255.812 368 235.812 412 191.812 360",
    className: "colorf5f5f5 svgShape"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#354d59",
    d: "M191.812 360L176 364l-16 56 24 8-8 32 38.944 48.68c8.368 1.348 16.868 2.288 25.484 2.804L191.812 360zM336 364l-15.812-4-48.616 151.484c8.616-.516 17.116-1.456 25.484-2.804L336 460l-8-32 24-8L336 364z",
    className: "color354d59 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIcon);
export default __webpack_public_path__ + "static/media/employerIcon.3d58df000c0a81bdc088e878edfcdc22.svg";
export { ForwardRef as ReactComponent };